import { Grid, Typography, Box, Tabs, Tab, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Loadable } from '../../../common';
import { Portlet } from '../../../partials/content/Portlet';

const useStyles = makeStyles(theme => ({
    titleDiv: {
        padding: '16px 24px',
        borderBottom: `1px solid ${theme.palette.secondary.main}`,
    },
    tabsRoot: {
        borderBottom: `1px solid ${theme.palette.secondary.main}`,
        padding: '0 24px',
    },
    tab: {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '14px',
        minWidth: 140,
    },
    contentDiv: {
        padding: '24px',
    },
    noContent: {
        color: theme.palette.text.secondary,
        padding: theme.spacing(4),
        textAlign: 'center',
    },
    loaderDiv: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(6),
    },
    pdfFrame: {
        width: '100%',
        height: '80vh',
        border: 'none',
    },
}));

function VersionUpdatePage(props) {
    const {
        getReleaseNotesPending,
        getReleasePdfUrlPending,
        releases,
        releasePdfUrl,
        actions: {
            getReleaseNotes,
            getReleasePdfUrl,
        }
    } = props;

    const classes = useStyles();
    const [selectedTab, setSelectedTab] = useState(0);
    const [pdfLoadError, setPdfLoadError] = useState(false);
    const initialFetchDone = useRef(false);

    useEffect(() => {
        getReleaseNotes();
    }, [getReleaseNotes]);

    useEffect(() => {
        if (releases && releases.length > 0 && !initialFetchDone.current) {
            initialFetchDone.current = true;
            const firstRelease = releases[0];
            if (firstRelease.fileName) {
                getReleasePdfUrl(firstRelease.id);
            }
        }
    }, [releases, getReleasePdfUrl]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setPdfLoadError(false);
        const selected = releases[newValue];
        if (selected?.fileName) {
            getReleasePdfUrl(selected.id);
        }
    };

    const selectedRelease = releases && releases[selectedTab];
    const showPdf = releasePdfUrl && selectedRelease?.fileName && !pdfLoadError;

    return (
        <Loadable loading={getReleaseNotesPending}>
            <Helmet title="Version Updates" />
            <Portlet>
                <Grid container className={classes.titleDiv}>
                    <Grid item xs={12}>
                        <Typography variant="h5">
                            <b>Release Versions</b>
                        </Typography>
                    </Grid>
                </Grid>

                {releases && releases.length > 0 && (
                    <Tabs
                        value={selectedTab}
                        onChange={handleTabChange}
                        className={classes.tabsRoot}
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {releases.map((release) => (
                            <Tab
                                key={release.id}
                                label={`v${release.version}`}
                                className={classes.tab}
                            />
                        ))}
                    </Tabs>
                )}

                <Box className={classes.contentDiv}>
                    {getReleasePdfUrlPending ? (
                        <div className={classes.loaderDiv}>
                            <CircularProgress size={32} />
                        </div>
                    ) : showPdf ? (
                        <iframe
                            className={classes.pdfFrame}
                            src={releasePdfUrl}
                            title={`Release v${selectedRelease.version}`}
                            onError={() => setPdfLoadError(true)}
                        />
                    ) : (
                        <Typography className={classes.noContent}>
                            No release notes available for this version.
                        </Typography>
                    )}
                </Box>
            </Portlet>
        </Loadable>
    );
}

export default VersionUpdatePage;